import { Injectable, inject } from '@angular/core'
import { RestClientList } from '@elderbyte/ngx-starter'
import { HttpClient } from '@angular/common/http'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { BatchTracingSpec } from './batch-tracing-spec'
import { environment } from '../../../../environments/environment'

@Injectable({
  providedIn: 'root',
})
export class BatchTracingSpecService extends RestClientList<BatchTracingSpec, string> {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    const http = inject(HttpClient)

    super(environment.apiPath + '/batch-tracing/spec', http, {
      idField: 'id',
    })
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/
}
